import createAction from '../../../utils/redux-helpers/createAction';
import { initState } from '../../initState';

const handler = () => initState;

export const logout = createAction({
  action: ['logout'],
  handler,
});
